var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button",class:{ 'switch-button_enable': _vm.value, 'switch-button_disabled': _vm.disabled },style:({ '--color': _vm.color, '--size': _vm.size }),on:{"click":_vm.onClick}},[_c('div',{staticClass:"switch-button__button"})])
}
var staticRenderFns = []

export { render, staticRenderFns }